import React from 'react'
import {
  BrowserRouter as Router,
  Switch,
  Route
} from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid'
import { PrivateRoute, RedirectPage } from '../tools'
import Login from './Login'
import VehicleManagement from './VehicleManagement'
import ContractManagement from './ContractManagement'
import VehicleReport from './VehicleReport'
import { useSelector, useDispatch } from 'react-redux'
import VehicleDetail from './VehicleManagement/VehicleDetail'
import EditVehicle from './VehicleManagement/EditVehicle'
import { userInfo } from './../features/users/userInfoSlice'
import PageNotFound from './PageNotFound'
import UserManagement from './UserManagement'
import DropDownManagement from './DropDownManagement'
import EditDropDown from './DropDownManagement/EditDropDown'
import ForkliftManagement from './ForkliftManagement'
import ForkliftContractManagement from './ForkliftContractManagement'
import EditForklift from './ForkliftManagement/EditForklift'
import ForkliftDetail from './ForkliftManagement/ForkliftDetail'
import { withTranslation } from 'react-i18next'

function initUid () {
  if (!localStorage.getItem('uid')) {
    localStorage.setItem('uid', uuidv4())
  }
}

function MainRoute () {
  initUid()
  const dispatch = useDispatch()
  const [userPage, setUserPage] = React.useState('')
  const [vehicleCreatePage, setVehicleCreatePage] = React.useState('')
  const [vehicleEditPage, setVehicleEditPage] = React.useState('')
  const [pageNotFound, setPageNotFound] = React.useState('')
  const [dropDwonPage, setDropDwonPage] = React.useState('')
  const [editDropDwonPage, setEditDropDwonPage] = React.useState('')
  const [forkliftCreatePage, setForkliftCreatePage] = React.useState('')
  const [forkliftEditPage, setForkliftEditPage] = React.useState('')
  const userState = useSelector(state => state.userInfo)
  React.useEffect(() => {
    if ((localStorage.getItem('token'))) {
      dispatch(userInfo())
    }
  }, [])

  React.useEffect(() => {
    if (!(localStorage.getItem('token'))) {
      const currentPath = window.location.pathname
      if (currentPath !== '/login') {
        window.location.href = '/login'
      }
    }
    if (!userState.email) {
      return
    }
    if (userState.isSuperAdmin || userState.isAdmin) {
      setUserPage(<PrivateRoute path="/usermanagement" component={UserManagement} exact />)
    }
    if (userState.isSuperAdmin || userState.isEdit) {
      setVehicleCreatePage(<PrivateRoute path="/vehicle/create" component={EditVehicle} exact />)
    }
    if (userState.isSuperAdmin || userState.isEdit) {
      setVehicleEditPage(<PrivateRoute path="/editinfo/:id/edit" component={EditVehicle} exact />)
    }
    if (userState.isSuperAdmin) {
      setDropDwonPage(<PrivateRoute path="/dropdownmanagement" component={DropDownManagement} exact />)
    }
    if (userState.isSuperAdmin) {
      setEditDropDwonPage(<PrivateRoute path="/dropdownmanagement/edit/:id" component={EditDropDown} exact />)
    }
    if (userState.isSuperAdmin || userState.isEdit) {
      setForkliftCreatePage(<PrivateRoute path="/forklift/create" component={EditForklift} exact />)
    }
    if (userState.isSuperAdmin || userState.isEdit) {
      setForkliftEditPage(<PrivateRoute path="/forklifteditinfo/:id/edit" component={EditForklift} exact />)
    }
    setPageNotFound(<Route path="*" component={PageNotFound} />)
  }, [userState])

  return (
    <Router>
      <Switch>
        <Route path="/login" component={Login} />
        <Route path="/redirect" component={RedirectPage} />
        <PrivateRoute path="/" component={VehicleManagement} exact />
        <PrivateRoute path="/vehicle" component={VehicleManagement} exact />
        <PrivateRoute path="/contract" component={ContractManagement} exact />
        <PrivateRoute path="/report" component={VehicleReport} exact />
        <PrivateRoute path="/viewinfo/:id" component={VehicleDetail} exact />
        <PrivateRoute path="/forklift" component={ForkliftManagement} exact />
        <PrivateRoute path="/forkliftContract" component={ForkliftContractManagement} exact />
        <PrivateRoute path="/forkliftviewinfo/:id" component={ForkliftDetail} exact />
        {userPage}
        {vehicleEditPage}
        {vehicleCreatePage}
        {forkliftEditPage}
        {forkliftCreatePage}
        {dropDwonPage}
        {editDropDwonPage}
        {pageNotFound}
    </Switch>
    </Router>
  )
}

export default withTranslation()(MainRoute)
